import "../winningVouchers.css";

const AgentLayout = ({ children, className = "" }) => (
  <div className={`agent-portal ${className}`.trim()}>{children}</div>
);

export default AgentLayout;
